import request from './request';
import { getToken } from '@/utils/token';

const createAnchorLink = (href, filename = '') => {
  console.log('href', href);
  const a = document.createElement('a');
  a.download = filename;
  a.href = href;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

const downLoadPrivateFile = (path) => {
  const apiToken = `${getToken()}`;
  const a = document.createElement('a');
  a.href = `${window.location.origin}/bizgrowth/web/v1/common/download?uri=${path}&access_token=${apiToken}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};
// 下载使用这个，上面的弃用
const newDownLoadPrivateFile = (path) => {
  const apiToken = `${getToken()}`;
  const a = document.createElement('a');
  a.href = `${
    window.location.origin
  }/bizgrowth/web/v1/common/download?uri=${encodeURIComponent(
    path,
  )}&access_token=${apiToken}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/**
 * 下载
 * @param {*} url 下载接口
 * @param {*} parmObj 请求参数
 * @param {*} filename 文件名
 * @param {*} type 文件类型
 */
const download = (
  url,
  parmObj,
  filename,
  method,
  type,
  // type = 'application/vnd.ms-excel',
  setLoading = () => {},
  setOpenMessage = () => {},
  setType = () => {},
  setMessage = () => {},
) => {
  // fetch(url)

  request(url, {
    method: method ?? 'POST',
    data: {
      ...parmObj,
    },
    responseType: 'blob', // 响应类型必须设置
    getResponse: true,
  })
    .then(({ data, response }) => {
      setLoading();
      let blob = new Blob([data], { type });
      const blobUrl = window.URL.createObjectURL(blob);

      //  获取响应中的filename
      const contentDisposition = response.headers.get('Content-Disposition');
      console.log('💢felix => .then => contentDisposition', contentDisposition);
      const resFileName =
        contentDisposition && decodeURI(contentDisposition.split("''")?.[1]);
      console.log('💢felix => .then => resFileName', resFileName);
      const downloadFileName = resFileName ?? filename;
      createAnchorLink(blobUrl, downloadFileName || filename);
      window.URL.revokeObjectURL(blobUrl);
      setLoading(false);
    })
    .catch((err) => {
      console.log('💢 => //.then => err', err);
      setOpenMessage(true);
      setTimeout(() => {
        setOpenMessage(false);
      });
      setType(false);
      setMessage('该条件下没有数据可以导出');
      setLoading(false);
    });
  // request(url, {
  //   method: 'GET',
  //   params: {
  //     ...parmObj,
  //   },
  //   responseType: 'blob', // 响应类型必须设置
  //   getResponse: true,
  // });
  //   .then(({ data, response }) => {
  //     let blob = new Blob([data], { type: type });
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     // 获取响应中的filename
  //     const contentDisposition = response.headers.get('Content-Disposition');
  //     console.log('💢felix => .then => contentDisposition', contentDisposition);
  //     const resFileName =
  //       contentDisposition && decodeURI(contentDisposition.split("''")?.[1]);
  //     console.log('💢felix => .then => resFileName', resFileName);
  //     const downloadFileName = resFileName ?? filename;
  //     createAnchorLink(blobUrl, downloadFileName);
  //     window.URL.revokeObjectURL(blobUrl);
  //     setLoading(false);
  //   })
  //   .catch((err) => {
  //     console.log('💢 => //.then => err', err);
  //     setOpenMessage(true);
  //     setTimeout(() => {
  //       setOpenMessage(false);
  //     });
  //     setType(false);
  //     setMessage('该条件下没有数据可以导出');
  //     setLoading(false);
  //   });
};
const downloadCsv = (
  url,
  parmObj,
  filename,
  // type,
  // type = 'application/vnd.ms-excel',
) => {
  createAnchorLink(url, filename);
};
const uploadExcel = (file, formData, url, callback) => {
  request(url, {
    method: 'POST',
    data: formData,
  })
    .then((res) => {
      console.log('💢 => //.then => res', res);
      if (res?.code !== 0) {
        res?.message &&
          window.message.toast({
            type: 'error',
            message: res?.message,
          });
      }
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    })
    .catch((err) => {
      console.log('💢 => //.then => err', err);
      callback && callback();
      // setDataUrl(undefined);
    });
};

export {
  download,
  downloadCsv,
  uploadExcel,
  downLoadPrivateFile,
  newDownLoadPrivateFile,
  createAnchorLink,
};
